import { ManageFunnelIdReturn } from './utils.decl';

import { generateUniqId } from '@dashboard/library';

/**
 * @deprecated once we update `@dashboard/library` to v2.36.0+ we should delete this code
 */
export function manageFunnelId(sessionStorageKey: string): ManageFunnelIdReturn {
  function setAndReturnNewFunnelId() {
    const funnelId = generateUniqId();

    sessionStorage.setItem(sessionStorageKey, funnelId);

    return funnelId;
  }

  return {
    setAndReturnNewFunnelId,
  };
}
